/**
 * Canonical links to the OICNM student app (app.theoicnm.com) and the
 * legacy Classe365 portal. Declared in one place so every "Apply", "Sign up",
 * "Login" and scholarship CTA across the marketing site stays consistent.
 */

// Root of the new student application/self-service app.
export const APP_URL = "https://app.theoicnm.com";

// Where prospective students begin an application / create an account.
export const APP_SIGNUP_URL = `${APP_URL}/signup`;

// Student Finance Portal — pay tuition/application/custom charges, view
// invoices & payment history, pick installment plans, apply for scholarships.
export const APP_STUDENT_URL = `${APP_URL}/student`;

// Direct link to the scholarship application inside the student app.
export const APP_SCHOLARSHIP_URL = `${APP_URL}/student/scholarships`;

// Legacy academic portal (Classe365) — where enrolled students access classes,
// grades and academic records.
export const CLASSE365_PORTAL_URL = "https://theoicnm.classe365.com";
